import { render, staticRenderFns } from "./ScannedPage.vue?vue&type=template&id=e18c42dc&scoped=true&"
import script from "./ScannedPage.vue?vue&type=script&lang=js&"
export * from "./ScannedPage.vue?vue&type=script&lang=js&"
import style0 from "./ScannedPage.vue?vue&type=style&index=0&id=e18c42dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18c42dc",
  null
  
)

export default component.exports